// Import dependencies
import React from 'react';
import cookie from 'js-cookie';

class LogoutButton extends React.Component {

    handleLogout = () => {
        // Remove the token and user-type from the cookie
        console.log('logout');
        cookie.remove('user-type', { path: '/' });
        cookie.remove('token', { path: '/' });
        window.location.reload();
    }

    render() {
        return (
            (this.props.size === 'small') ?
                <button className='btn btn-secondary btn-sm' onClick={this.handleLogout}>Logout</button>
                :
                <button className='btn btn-secondary' onClick={this.handleLogout}>Logout</button>


        );
    }
}

export default LogoutButton;